import React from "react";
import { Helmet } from "react-helmet";
import Header from "../Components/Header";
import Nav from "../Components/Nav";

function Agreement() {
  const styles = {
    checkboxLabel: {
      marginLeft: "0.5rem",
      fontSize: "0.9rem",
      color: "#6c757d",
    },
    btnList: {
      display: "flex",
      gap: "1rem",
      marginTop: "1rem",
    },
  };

  return (
    <div>
      <Helmet>
        <script src="forthfunded/popper.min.js" />
        <script src="forthfunded/bootstrap.bundle.min.js" />
        <script src="forthfunded/defaultmenu.min.js" />
        <script src="forthfunded/waves.min.js" />
        <script src="forthfunded/sticky.js" />
        <script src="forthfunded/simplebar.min.js" />
        <script src="forthfunded/simplebar.js" />
        <script src="forthfunded/pickr.es5.min.js" />
        <script src="forthfunded/apexcharts.min.js" />
        <script src="forthfunded/crypto-dashboard.js" />
        <script src="forthfunded/custom-switcher.min.js" />
        <script src="forthfunded/custom.js" />
      </Helmet>


      <div className="page">
        <Header />
        <Nav />

        <main className="main-content app-content">
          <div className="container-fluid">
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <h1 className="page-title fw-semibold fs-18 mb-0">Terms of Service</h1>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item"><a href="/dashboards">Dashboard</a></li>
                  <li className="breadcrumb-item active" aria-current="page">Terms</li>
                </ol>
              </nav>
            </div>

            <div className="container-lg">
              <div className="row justify-content-center">
                <div className="col-xl-8">
                  <div className="card custom-card overflow-hidden">
                    <div className="card-body p-0">
                      <div className="p-3 terms-heading-cover d-flex align-items-center text-fixed-white bg-primary h5 fw-semibold mb-0">
                        <span className="avatar avatar-md me-3">
                          <img src="../assets/images/media/media-67.png" alt="terms" />
                        </span>
                        Terms Of Service
                      </div>

                      <div className="p-4 text-muted terms-conditions" id="terms-scroll">
                        <section className="mb-5">
                          <p className="mb-3 op-7">
                            <strong className="text-default op-8">Carefully read through the Agreement.</strong>
                          </p>
                          <p className="mb-0 op-7">
                            This Agreement sets out the specific terms that apply to you when using the compounding functionality on FarYieldFi Investment platform. These terms apply in addition to the General Terms and Conditions.
                          </p>
                          <br />
                          <p className="mb-0 op-7">
                            If a term in this Agreement conflicts with the General Terms and Conditions, this Agreement will apply.
                          </p>
                        </section>

                        <h6 className="fw-bold pb-3 text-default op-7">
                          <span className="terms-heading">Introduction</span>
                        </h6>

                        <section className="mb-4">
                          <p className="fw-semibold text-muted mb-2 fs-14">1: Compounding Cycle Duration</p>
                          <ul>
                            <li>Each compounding cycle runs for a fixed period of 4 months.</li>
                            <li>Your investment will grow based on the reinvestment of profits.</li>
                          </ul>
                        </section>

                        <section className="mb-4">
                          <p className="fw-semibold text-muted mb-2 fs-14">2: Capital Updates and Portfolio Adjustments</p>
                          <ul>
                            <li>The company will assess your portfolio periodically.</li>
                            <li>You will be notified via Email if additional capital is needed.</li>
                            <li>Timelines and amounts will be communicated in advance.</li>
                          </ul>
                        </section>

                        <section className="mb-4">
                          <p className="fw-semibold text-muted mb-2 fs-14">3: Withdrawal Restrictions</p>
                          <ul>
                            <li>No withdrawals during the 4-month compounding cycle.</li>
                            <li>Funds become accessible at the end of the cycle.</li>
                          </ul>
                        </section>

                        <section className="mb-4">
                          <p className="fw-semibold text-muted mb-2 fs-14">4: Acknowledgment and Agreement</p>
                          <ul>
                            <li>Activating your account means you accept these terms.</li>
                            <li>Violation may lead to penalties or account suspension.</li>
                          </ul>
                        </section>
                      </div>
                    </div>

                    {/* ✅ REPLACED FOOTER BUTTON SECTION HERE */}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "1rem",
                        paddingTop: "10rem",
                        boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)"
                      }}
                    >
                      <div>
                        <input type="checkbox" id="privacy-policy" defaultChecked required />
                        <label htmlFor="privacy-policy" style={styles.checkboxLabel}>
                          I agree with the
                        </label>
                        <a href="../privacy" style={styles.checkboxLabel}><u>Privacy Policy</u></a>
                      </div>
                      <div style={styles.btnList}>
                        <a href="/dashboards" style={{
                          padding: "0.5rem 1rem",
                          border: "1px solid red",
                          color: "red",
                          borderRadius: "5px",
                          textDecoration: "none"
                        }}>
                          I DECLINE
                        </a>
                        <a href="/compound" style={{
                          padding: "0.5rem 1rem",
                          backgroundColor: "green",
                          color: "white",
                          borderRadius: "5px",
                          textDecoration: "none"
                        }}>
                          I ACCEPT
                        </a>
                      </div>
                    </div>
                    {/* END REPLACEMENT */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

        <footer className="footer mt-auto py-3 bg-white text-center">
          <div className="container">
            <span className="text-muted">Copyright © 2025 </span>
            <a href="#" className="text-dark fw-semibold">FarYieldFi</a>. All Rights Reserved
            <div className="icon-before mt-2">
              <div className="icon-bar">
                <img src="../flag.png" alt="Language flag" width={160} />
                <div id="google_translate_element" />
              </div>
            </div>
          </div>
        </footer>

        <style
          dangerouslySetInnerHTML={{
            __html: `
              body { top: 0px !important; }
              body>.skiptranslate { display: none; }
              .goog-logo-link, .goog-te-gadget { display: none !important; color: transparent !important; }
              .goog-te-banner-frame.skiptranslate { display: none !important; }
              .icon-before { position: relative; width: 160px; }
              #goog-gt-tt, .goog-tooltip.skiptranslate, .activity-root, .status-message, .started-activity-container {
                display: none !important;
              }
              #google_translate_element { color: transparent; }
              #google_translate_element a { display: none; }
              .icon-bar {
                position: relative;
                left: 0;
                bottom: 0;
                width: 100%;
                background-color: white;
                color: black;
                text-align: center;
              }
            `
          }}
        />

        <noscript>
          Powered by <a href="https://www.smartsupp.com" target="_blank" rel="noreferrer">Smartsupp</a>
        </noscript>
      </div>

      <div className="scrollToTop">
        <span className="arrow">
          <i className="ri-arrow-up-s-fill fs-20" />
        </span>
      </div>
      <div id="responsive-overlay" />
    </div>
  );
}

export default Agreement;
